import React from 'react';
import { useSelector } from 'react-redux';
import getCategoryDisplayPreferences from 'store/category/selector/getCategoryDisplayPreferences';
import DesktopOnly from 'components/Common/Utils/DesktopOnly';
import CategoriesList from './CategoriesList/CategoriesList';
import styles from './Sidebar.module.scss';
import Filters from './Filters/Filters';

const Sidebar = () => {
  const selectorsOnTheTop = useSelector(getCategoryDisplayPreferences)?.selectorsOnTheTop || false;

  return (
    <div className={styles.sidebar}>
      <DesktopOnly>
        <Filters applyFiltersImmediately />
      </DesktopOnly>
      {!selectorsOnTheTop && <CategoriesList />}
      {/* <ItemsFilter /> */}
      {selectorsOnTheTop && <CategoriesList />}
    </div>
  );
};

export default Sidebar;
